import { Component, OnInit } from '@angular/core';
import { Comment, MovieModel } from 'src/app/core/interfaces/movie.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { MoviesService } from 'src/app/core/services/movies.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reconnect',
  templateUrl: './reconnect.component.html',
  styleUrls: ['./reconnect.component.scss']
})
export class ReconnectComponent implements OnInit {

  loading = false;

  //#region First Slide Show
  firstSlideShow: MovieModel[] = [];
  firstSlideShowTitle = "Peliculas populares este mes"
  firstSlideShowSwiperIndex = 0;
  firstSlideShowConfig = {
    slidesPerView: 2,
    spaceBetween: -10,
    navigation: true,
    breakpoints: {
      480: { slidesPerView: 4 },
      700: { slidesPerView: 5 },
      1000: { slidesPerView: 8 },
      1600: { slidesPerView: 8 }
    }
  }
  //#endregion

  //#region Comments

  commentList1: Comment[] = [];
  commentList2: Comment[] = [];
  popularReviewsTitle = "Reseñas populares este mes"
  //#endregion

  //#region First Card Show
  firstCardShow: MovieModel[] = [];
  firstCardShowTitle = "Nuevas Incorporaciones"
  firstCardShowSwiperIndex = 0;
  firstCardShowConfig = {
    slidesPerView: 1,
    spaceBetween: -10,
    navigation: true,
    breakpoints: {
      525: { slidesPerView: 2 },
      800: { slidesPerView: 3 },
      900: { slidesPerView: 4 },
      1250: { slidesPerView: 5 }
    }
  }
  //#endregion

  //#region First Card Show
  secondCardShow: MovieModel[] = [];
  secondCardShowTitle = "Estrenos"
  secondCardShowSwiperIndex = 0;
  secondCardShowConfig = {
    slidesPerView: 1,
    spaceBetween: -10,
    navigation: true,
    breakpoints: {
      525: { slidesPerView: 2 },
      800: { slidesPerView: 3 },
      900: { slidesPerView: 4 },
      1250: { slidesPerView: 5 }
    }
  }
  //#endregion

  //#region Critics Reviews
  criticReviewsTitle = "Opiniones de criticos"
  criticReview1: Comment;
  criticReview2: Comment;
  //#endregion


  filters: filterItem[];

  constructor(
    private moviesService: MoviesService,
    private categoryService: CategoriesService,
  ) { }

  ngOnInit(): void {
    this.fillFilters();
    this.loadContent();
  }

  loadContent() {
    this.loadFirstSlideShow();
    this.loadPopularReviews();
    this.loadFirstCardShow();
    this.loadSecondCardShow();
    this.loadCriticReviews();
  }

  loadPopularReviews() {
    let cantidad = 3;
    this.moviesService.getMonthPopularComments().subscribe((res) => {
      this.commentList1 = res.slice(0, cantidad);
      this.commentList2 = res.slice(cantidad, cantidad + cantidad);
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );
  }

  loadFirstSlideShow() {
    this.moviesService.getFeaturedMovies().subscribe((resp: MovieModel[]) => {
      this.categoryService.getCategoryByIdWithMovies(6).subscribe((resp2) => {
        if (resp) this.firstSlideShow = [...resp, ...resp2[0].movies];
      });
    });
  }

  loadFirstCardShow() {
    this.categoryService.getCategoryByIdWithMovies(29).subscribe((resp) => {
      if (resp) this.firstCardShow = resp[0].movies;

    });
  }

  loadSecondCardShow() {
    this.categoryService.getCategoryByIdWithMovies(6).subscribe((resp) => {
      if (resp) this.secondCardShow = resp[0].movies;

    });
  }

  loadCriticReviews() {

    this.moviesService.getCriticsReviews().subscribe((res) => {

      //LOS IFS SON PARA FAILSAFE.
      if (res.length > 0) {
        this.criticReview1 = res[0];//la ultima review hecha
        if (res.length > 1) {
          this.criticReview2 = res[1];//la pen-ultima review hecha
        }
      }


      /* CODIGO PARA AGARRAR REVIEWS RANDOM. 
      let min = 0;
      let max = res.length - 1;
      let random1 = Math.floor(Math.random() * (max - min + 1) + min);//ESTO ES UN RANDOM ENTRE DOS NUMEROS MAX Y MIN
      let random2 = Math.floor(Math.random() * (max - min + 1) + min);//ESTO ES UN RANDOM ENTRE DOS NUMEROS MAX Y MIN
      
      this.criticReview1 = res[random1];
      this.criticReview2 = res[random2];
      */

    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

  }



  //#region Filtros TO-DO

  onFilterChanged(filter: filterTypes) {
    let changed = this.filters.find(f => f.type == filter);
    changed.active = !changed.active;
    //posiblemente chequear si ya tiene contenido cargado, sino cargarlo.   
  }

  fillFilters() {
    this.filters = [];
    let ffilm = { type: filterTypes.films, active: true }
    this.filters.push(ffilm);
    let freview = { type: filterTypes.reviews, active: true }
    this.filters.push(freview);
    let fcritics = { type: filterTypes.critics, active: true }
    this.filters.push(fcritics);
    let fmembers = { type: filterTypes.members, active: true }
    this.filters.push(fmembers);
  }

  //#endregion

}

interface filterItem {
  type: filterTypes;
  active: boolean;
}

enum filterTypes {
  films = 0,
  reviews = 1,
  critics = 2,
  members = 3,
}